import { ProductSlider } from './ProductSlider'
import { useProductAttributes } from '../../../state'

export function UpsellProducts() {
  const { upsellProducts, loadingRelated } = useProductAttributes()

  return (
    <ProductSlider
      products={upsellProducts}
      loading={loadingRelated}
      title="Accesorii compatibile"
    />
  )
}
